import { Card, Stack } from '@mui/material';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';
import Scrollbar from '../../../../reusable-components/scrollbar';
import { markAsRead } from '../../../../redux/slices/tickets';
import TicketMessageInput from './TicketMessageInput';
import TicketMessageList from './TicketMessageList';
import TicketSubject from './TicketSubject';

export default function Ticket() {
  const { id = '' } = useParams();
  const location = useLocation();
  const subticketId = new URLSearchParams(location.search).get('subticket');
  const dispatch = useDispatch();
  const scrollRef = useRef(null);
  const { ticketMessages } = useSelector(
    (state) => state.tickets.data.ticketById[ subticketId || id] || {}
  );
  const { allTicketUsers } = useSelector(
    (state) => state.tickets.data.ticketInfoById[ subticketId || id] || {}
  ) || {};

  const markRead = async (ticketId) => {
    await dispatch(markAsRead(ticketId));
  };
  
  useEffect(() => {
    if (id) {
      markRead(id);
    }
  }, [id]);

  useEffect(() => {
    if (subticketId) {
      markRead(subticketId);
    }
    else {
      markRead(id);
    }
  }, [subticketId]);

  useEffect(() => {
    if(scrollRef.current){
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight; 
    }
  }, [ticketMessages, allTicketUsers]);

  return (
    <Card sx={{
      maxHeight: '90vh',
      display: 'flex',
      px: '20px',
      pb: '20px',
      overflowY: 'auto',
      boxSizing: 'border-box'
    }}>
      <Stack flexGrow={1} sx={{maxWidth: '100%'}}>
        <TicketSubject />
        <Stack
          direction="column"
          justifyContent="flex-end"
          flexGrow={1}
          sx={{
            overflowY: 'auto',
            border: '2px solid #208ee0',
            borderRadius: '5px',
            boxShadow: '0px 3px 5px 2px grey',
          }}
        >
          <Stack
            ref={scrollRef}
            flexGrow={1}
            sx={{
              px: 2,
              overflowY: 'auto',
              minHeight: '200px'
            }}
          >
            <TicketMessageList />
          </Stack>
          <Stack flexGrow={1}>
            <Scrollbar>
              <TicketMessageInput />
            </Scrollbar>
          </Stack>
        </Stack>
      </Stack>
    </Card>
  );
}
